import type { StateCreator } from "zustand";
import type { Resolution } from "./pick-resolution";

/** Keyed by streamId. A bar and a line on one panel can resolve differently. */
export type StreamResolutions = Record<number, Resolution>;

export interface PanelResolutionSlice {
    panelResolutions: Record<string, Record<string, StreamResolutions>>;
    setPanelResolutions: (groupId: string, panelId: string, resolutions: StreamResolutions) => void;
    clearPanelResolutions: (groupId: string, panelId: string) => void;
}

export const createPanelResolutionSlice: StateCreator<PanelResolutionSlice, [], [], PanelResolutionSlice> = (set) => ({
    panelResolutions: {},
    setPanelResolutions: (groupId, panelId, resolutions) =>
        set((state) => ({
            panelResolutions: {
                ...state.panelResolutions,
                [groupId]: { ...state.panelResolutions[groupId], [panelId]: resolutions },
            },
        })),
    clearPanelResolutions: (groupId, panelId) =>
        set((state) => {
            const group = state.panelResolutions[groupId];
            if (!group) return state;
            const rest = { ...group };
            delete rest[panelId];
            return { panelResolutions: { ...state.panelResolutions, [groupId]: rest } };
        }),
});
